import { QueryFactory } from "../../../../Common";
export const QGetEvents = QueryFactory("GetEvents");
//# sourceMappingURL=QGetEvents.js.map